import { Box, TabPanels, Tabs } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import {
    ContentTab,
    TabCustom,
    TabListCustom,
    TabPanelCustom,
    TabTitle
} from 'pages/Contract/styles'
import { DetranBillingReports } from './components/DetranBillingReports'
import { DetranManagementReport } from './components/DetranManagementReport'
import { ManagementReport } from './components/ManagementReport'
import { RevenueReport } from './components/RevenueReport'

const Report = () => {
    return (
        <Tabs
            isLazy
            style={{
                background: 'transparent'
            }}
            as={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            height="100%"
        >
            <TabListCustom
                style={{
                    background: 'transparent'
                }}
            >
                <ContentTab>
                    <TabCustom>Relatório de Operações</TabCustom>
                    <TabCustom>Relatório de Faturamento</TabCustom>
                    <TabCustom>Relatório de Cobrança Detran (PR/RN)</TabCustom>
                    <TabCustom>Relatório de Gestão do Detran (ES)</TabCustom>
                </ContentTab>
            </TabListCustom>
            <TabTitle
                pt={4}
                style={{
                    background: 'transparent'
                }}
            ></TabTitle>
            <TabPanels>
                <TabPanelCustom
                    style={{
                        background: 'transparent'
                    }}
                >
                    <Box>
                        <ManagementReport />
                    </Box>
                </TabPanelCustom>
                <TabPanelCustom
                    style={{
                        background: 'transparent'
                    }}
                >
                    <RevenueReport />
                </TabPanelCustom>
                <TabPanelCustom
                    style={{
                        background: 'transparent'
                    }}
                >
                    <DetranBillingReports />
                </TabPanelCustom>
                <TabPanelCustom style={{ background: 'transparent' }}>
                    <DetranManagementReport />
                </TabPanelCustom>                
            </TabPanels>
        </Tabs>
    )
}

export default Report
